import ShopBasketItemsListModelBase from '../_generated/modelBases/shop-basket-items-list-model-base';

export default class ShopBasketItemsListModel extends ShopBasketItemsListModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
